import { Link } from 'react-router-dom';
import { articles } from '@/mocks/navigationData';

export default function ArticleList() {
  const recentArticles = articles.slice(0, 3);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选推荐文章
            </h2>
            <p className="text-sm text-foreground-600">
              实用的网址推荐与使用技巧，助你高效上网
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {recentArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-accent-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-white/90 text-foreground-800 text-xs font-medium">
                    {article.category.replace('-', ' ')}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-accent-100 flex items-center justify-center">
                      <i className="ri-user-line text-xs text-accent-600"></i>
                    </div>
                    <span className="text-xs text-foreground-500">{article.author}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/article/2025-bi-bei-gong-ju"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-300 text-foreground-600 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-all duration-200"
          >
            查看更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}